import { useGetVehicleDetails } from '~/context/vdp/VehicleContext';
import useIncentives from '~/hooks/vdp/selectors/useIncentives';
import FactoryUpgradesBadge from './FactoryUpgradesBadge';
import IncentivesBadge from './IncentivesBadge';

export default function Highlights() {
  const { factoryUpgrades } = useGetVehicleDetails();
  const { maxIncentivesAmount } = useIncentives();

  const showLoyaltyIncentives = Boolean(maxIncentivesAmount);
  const factoryUpgradesMsrp = factoryUpgrades?.factoryUpgradesMsrp ?? 0;
  const showFactoryUpgrades = Boolean(factoryUpgradesMsrp);

  return showFactoryUpgrades || showLoyaltyIncentives ? (
    <div className="flex w-full flex-col gap-sm pt-md">
      {showLoyaltyIncentives && (
        <IncentivesBadge maxIncentivesAmount={maxIncentivesAmount} />
      )}
      {showFactoryUpgrades && (
        <FactoryUpgradesBadge factoryUpgradesMsrp={factoryUpgradesMsrp} />
      )}
    </div>
  ) : null;
}
